import React from 'react';
import { urlparams } from '../../config/bootstrap';
import { NavLink } from 'react-router-dom'
import { getUrlParameter, translation } from '../../utils/helper';
import { shareSuccessStore } from '../../config/store';




class Carousel extends React.Component {
    render() {
        let { data, next, prev, hideNavigation } = this.props;
        var nextlink = "/";
        var prevlink = "/";
        if (next) {
            nextlink = "/module/" + next;
        }
        if (prev) {
            prevlink = "/module/" + prev;
        }
        var viewPort = getUrlParameter('view');
        if (viewPort != "webview") {
            return (
                <div className="c_head_section">
                    <div className="row">
                        <div className="col-5">
                            {
                                !hideNavigation && (
                                    <NavLink to={prevlink + urlparams} >
                                        <div className="a_arrow_l" onClick={() => {
                                            shareSuccessStore.dispatch({
                                                type: "SET_SHARED",
                                                data: { shared: false },
                                            });
                                        }}>
                                            <img src="/assets/img/a_left.png" className="a_lr_img" />
                                        </div>
                                    </NavLink>
                                )
                            }
                            {/* <img src="/assets/img/activity_hd_img.png" className="a_hd_img" /> */}
                            <img src={data && data.forheader[0]} className="a_hd_img" />

                        </div>
                        <div className="col-7">
                            {
                                !hideNavigation && (
                                    <NavLink to={nextlink + urlparams} >
                                        <div className="a_arrow_r" onClick={() => {
                                            shareSuccessStore.dispatch({
                                                type: "SET_SHARED",
                                                data: { shared: false },
                                            });
                                        }}>
                                            <img src="/assets/img/a_right.png" className="a_lr_img" />
                                        </div>
                                    </NavLink>
                                )
                            }
                            <div className="acitivity_txt_wrp">
                                {/* <h4><span>Mantra 1</span> / <span>Activity 1</span></h4> */}
                                <h4>{data && data.inner_name ? data.inner_name : ''}</h4>
                                <h6>{data && data.inner_text ? data.inner_text : ''}
                                </h6>
                            </div>
                        </div>
                    </div>
                    {/* <div className="carousel_bg">
                        <div className="container">
                            <div className="carousel_div">
                                <NavLink to={prevlink + urlparams} >
                                    <button type="button"><img src="/assets/img/chevronprev.png" className=" chevron_img" alt="" /></button>
                                </NavLink>

                                <div className="carousel_cap">
                                    <h3>{data && data.inner_name ? data.inner_name : ''}</h3>
                                    <p>{data && data.inner_text ? data.inner_text : ''}</p>
                                </div>
                                <NavLink to={nextlink + urlparams} >
                                    <button type="button"><img src="/assets/img/chevronnext.png" className=" chevron_img" alt="" /></button>
                                </NavLink>
                            </div>

                        </div>
                    </div> */}
                </div>


            )
        } else {
            return (null);
        }
    }
}

export default Carousel;